module.exports = __webpack_public_path__ + "static/media/Kinder_How_It_Works.a650808b.pdf";